export const CAMPAIGN_STATUS = Object.freeze({
  BEFORE_START: 1,
  STARTED: 2,
  FINISHED: 3,
  STOP: 4,
  REMOVED: 99,
});

export const CAMPAIGN_STATUS_TEXT = Object.freeze({
  [CAMPAIGN_STATUS.BEFORE_START]: '開催前',
  [CAMPAIGN_STATUS.STARTED]: '開催中',
  [CAMPAIGN_STATUS.FINISHED]: '終了',
  [CAMPAIGN_STATUS.STOP]: '停止中',
  [CAMPAIGN_STATUS.REMOVED]: '削除済み',
});
